// extracted by mini-css-extract-plugin
module.exports = {"cpDetailAddressClass":"DetailsPage_cpDetailAddressClass__3lnvs","cpDetailsBuildingIcon":"DetailsPage_cpDetailsBuildingIcon__iv67U"};